export const MAX_SNAPCHAT_TAGS = 8;

export const MAX_SPECTACLES_TAGS = 8;

export const FOLDERS_AND_ORG_NAME_MAX_CHARS = 375;
